import React from 'react';

import { WithdrawalInputBase, WithdrawalInputBaseProps } from '@/widgets/Modals';

type WithdrawalInputProps<T> = T & WithdrawalInputBaseProps;

export const WithdrawalInput = <T,>({ ...props }: WithdrawalInputProps<T>) => {
    return (
        <WithdrawalInputBase
            label='Withdrawal APY'
            tooltipText='The annual percentage yield you receive when withdrawing assets from the pool.'
            {...props}
        />
    );
};
